<div class="color-palette-edit-component editor-container">
  <div class="flex-column stretch">
    <div class="editor-container-header">
      <div class="header-inner flex-row gap-8">
        <nw-icon type="palette" [size]="13" [outlined]="true"></nw-icon>
        <div>Color Palette</div>
      </div>
    </div>

    <div class="body flex-column gap-8 center">
      <div *ngIf="(orgColorPalette$ | async).length">
        <div class="title flex-row space-around">
          <div class="flex-row gap-8">
            <div>Organisation Colors</div>
            <nw-icon
              type="edit"
              [size]="12"
              (click)="navigateToOrgSettings()"
            ></nw-icon>
          </div>
        </div>
        <div class="org-colors flex-column gap-8">
          <div
            *ngFor="let element of orgColorPalette$ | async; let i = index"
            class="item flex-row space-between color-row"
          >
            <nw-editable-text
              [text]="element.name"
              (textChanged)="nameChanged($event, i)"
            ></nw-editable-text>
            <div class="flex-row gap-8">
              <nw-color-select
                [colors]="[element.code]"
                [noOptionSelect]="true"
                (changed)="colorChanged($event, i)"
              ></nw-color-select>
              <div style="width: 68px">
                <nw-editable-text
                  [text]="element.code"
                  [inputWidth]="60"
                  (textChanged)="colorChanged($event, i)"
                ></nw-editable-text>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        class="title"
        *ngIf="(orgColorPalette$ | async).length > 0; else placeHolder"
      >
        Project Colors
      </div>
      <ng-template #placeHolder>
        <div style="height: 10px"></div>
      </ng-template>
      <div
        *ngFor="let element of palette; let i = index"
        class="item position-relative flex-row space-between color-row"
        (mouseenter)="element.hover = true"
        (mouseleave)="element.hover = false"
      >
        <nw-editable-text
          [text]="element.name"
          (textChanged)="nameChanged($event, i)"
        ></nw-editable-text>
        <div class="flex-row gap-8">
          <nw-color-select
            [colors]="[element.code]"
            [noOptionSelect]="true"
            [saveClickOutside]="true"
            (changed)="colorChanged($event, i)"
            (closed)="save()"
          ></nw-color-select>
          <div class="flex-row" style="width: 68px">
            <div>#</div>
            <nw-editable-text
              [text]="element.code.slice(1)"
              [inputWidth]="60"
              (textChanged)="colorChanged('#' + $event, i)"
            ></nw-editable-text>
          </div>
        </div>
        <div
          class="position-absolute"
          style="right: -24px; top: 3px; z-index: 1"
        >
          <nw-icon
            type="close"
            class="close-icon"
            (click)="removeProjectColor(i, $event)"
          ></nw-icon>
        </div>
      </div>

      <div class="item flex-row start">
        <div class="add-container" (click)="addColor()">
          <nw-icon type="add" [size]="15"></nw-icon>
        </div>
      </div>
    </div>
    <!-- <div class="editor-footer flex-row space-around pointer">
      <div
        class="w-50 t-center fs-15"
        style="text-align: center; border-right: 1.25px solid black"
        (click)="save()"
      >
        Save
      </div>
      <div
        class="w-50 t-center fs-15"
        style="text-align: center"
        (click)="discard()"
      >
        Discard
      </div>
    </div> -->
  </div>
</div>
